export default [{
  header: 'Aprobaciones',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: { name: 'mobile-trays', params: { view: 'entrada-movil' } },
      name: 'Bandeja entrada',
      icon: 'InboxIcon',
      permiso: 'ED054' // TODO: set permission
    },
    {
      url: { name: 'mobile-trays', params: { view: 'salida' } },
      name: 'Bandeja salida',
      icon: 'ArchiveIcon',
      permiso: 'ED053' // TODO: set permission
    }
  ]
}];
